import React, { useState } from 'react';
import ContactModal from './ContactModal';
import './FloatingHelpButton.css';

const FloatingHelpButton = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openContactModal = () => {
        setIsModalOpen(true);
    };

    const closeContactModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="help-button">
                <button
                    className="floating-help-button"
                    onClick={openContactModal}
                    aria-label="Help"
                >
                    <span className="help-icon">?</span>
                    Help
                </button>
            </div>

            {isModalOpen && <ContactModal onClose={closeContactModal} />}
        </>
    );
};

export default FloatingHelpButton;
